import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { combineReducers } from '@ehi/global-marketing-interface/redux';
import BranchLocationTimeDrawer from 'components/BranchLocationDetail/BranchLocationTimeDrawer';
import BranchLocationMapView from 'components/BranchLocationDetail/BranchLocationMapView';
import locationSearchReducer from 'reducers/locationSearch';
import { getBranchHours } from 'actions/location';
import { recursiveFind } from './VehicleFilters';

/**
 * A public init method must exist to be called from uiManager
 * @param {Object} store The redux store for the site
 * @param {HTMLElement} domEl The dom element related to this module
 */
export default {
  init(store, domEl, model) {
    combineReducers(locationSearchReducer.reducer);
    const branchLocationDetails = model[':items'].root;

    if (branchLocationDetails) {
      if (domEl) {
        const branchHoursDiv = domEl.querySelector("div[data-branch-details-id='BranchLocationTimeDrawer']");
        const branchMapLocationDetailsDiv = domEl.querySelector("div[data-branch-details-id='BranchLocationMapView']");
        const branchLocationsModelJson = recursiveFind(model, 'aweb/components/content/location-details')?.lrdMap;
        const lat = branchLocationsModelJson.gps.latitude;
        const long = branchLocationsModelJson.gps.longitude;
        const branchId = branchLocationsModelJson.id;
        const locationType = branchLocationsModelJson.location_type;

        store.dispatch(getBranchHours(branchId));

        const address = branchLocationsModelJson.linkedData.fullAddress;
        const root = createRoot(branchHoursDiv);
        const branchRoot = createRoot(branchMapLocationDetailsDiv);
        root.render(
          <Provider store={store}>
            <BranchLocationTimeDrawer id={branchId} />
          </Provider>
        );

        branchRoot.render(
          <BranchLocationMapView address={address} lat={lat} long={long} locationType={locationType} />
        );
      }
    }
  },
};
